import { Mesh } from "three";

export enum MeshSelectionType {
    Single = "Single",
    Multiple = "Multiple",
}

export interface MeshSelection {
    mesh: Mesh;
    type: MeshSelectionType;
    materialIndex: number;
}
